import { OnboardingLayout } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { Translations, i18n } from "@i18n";
import { styles } from "./styles";

export const ErrorComponent = () => {
  return (
    <OnboardingLayout analytics={false}>
      <Spacing size={SpacingSizes.M} />

      <H2 style={styles.text}>{i18n.t(Translations.ErrorComponentTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.text}>{i18n.t(Translations.ErrorComponentSubtitle)}</Body>
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
